import { render, staticRenderFns } from "./TimelineSegmentCanvas.vue?vue&type=template&id=44904309&"
import script from "./TimelineSegmentCanvas.vue?vue&type=script&lang=js&"
export * from "./TimelineSegmentCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports